import { ComponentType } from 'react'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type'
import { ManualEntryProposalShowData } from '../types/maintenanceManualEntryProposal.type'
import ExecutionProposalAction from '../components/directiveEntries/execution/ExecutionProposalAction'
import ExecutionDiagnosticSection from '../components/directiveEntries/execution/ExecutionDiagnosticSection'
import ExecutionSentProposalExtras from '../components/directiveEntries/execution/ExecutionSentProposalExtras'
import DiagnosticProposalAction from '../components/directiveEntries/diagnostic/DiagnosticProposalAction'

export type ProposalDirectiveActionProps = {
  proposal: ManualEntryProposalShowData
  onAccepted?: () => void
}

export type ProposalDirectiveContentProps = {
  proposal: ManualEntryProposalShowData
}

type ProposalDirectiveEntryConfig = {
  AddProposalAction: ComponentType<ProposalDirectiveActionProps>
  DiagnosticSection?: ComponentType<ProposalDirectiveContentProps>
  SentProposalExtras?: ComponentType<ProposalDirectiveContentProps>
}

export const proposalDirectiveEntries: Partial<
  Record<MaintenanceForwardingsDirectiveEntryKlass, ProposalDirectiveEntryConfig>
> = {
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: {
    AddProposalAction: ExecutionProposalAction,
    DiagnosticSection: ExecutionDiagnosticSection,
    SentProposalExtras: ExecutionSentProposalExtras,
  },
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    AddProposalAction: DiagnosticProposalAction,
  },
}
